const luckyRouter = [
  {
    path: '/lucky/:id(\\d+)',
    name: 'LuckyDetail',
    component: () => import('@/views/lucky/detail')
  },
  {
    path: '/lucky/dashboard/:id(\\d+)',
    name: 'LuckyDashboard',
    component: () => import('@/views/lucky/dashboard')
  }
]
export default luckyRouter



// WEBPACK FOOTER //
// ./src/router/modules/lucky.js